import { Configuration, PublicClientApplication } from "@azure/msal-browser";

const mode = process.env.NODE_ENV;

export let msalConfig: Configuration;

if (mode === "development") {
    msalConfig = {
        auth: {
            clientId: 'c87a98a2-7334-4ccc-bf0d-c476f3a3aeae',
            redirectUri: 'http://localhost:8080/login',
            authority: 'https://login.microsoftonline.com/9d91af53-1f0d-4b5a-b211-36a2cd04336a',
        },
        cache: {
            cacheLocation: "localStorage",
        }
    }
} else {
    msalConfig = {
        auth: {
            clientId: '47c814d4-16ef-43ca-af54-8985ad84a928',
            redirectUri: 'https://testing.sobirussia.ru/login',
            authority: 'https://login.microsoftonline.com/2a2b3b7c-2102-4caf-911e-f24595387c50',
        },
        cache: {
            cacheLocation: "localStorage",
        }
    }
}

export const msalInstance = new PublicClientApplication(msalConfig);

export default msalConfig;